<template lang="pug">
v-img(
  src="/img/parts-bg.jpg",
  gradient="to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)",
  height="375px"
)
  v-container.d-flex.align-center.h-100
    .white--text
      .text-h4.font-weight-bold.mb-2 {{ title }}
      .text-h6.mb-3 {{ subtitle }}
      v-btn.text-none.black--text.px-8(
        :to="path",
        color="secondary",
        tile,
        depressed
      )
        span Veja mais
        v-icon(right, x-small) fas fa-chevron-right
</template>

<script>
export default {
  data: () => ({
    title: "Peças Genuínas a pronta Entrega",
    subtitle: "Atendemos todo Território Nacional.",
    path: "/pecas",
  }),
};
</script>

<style>
</style>